import { memo } from 'react';
import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@mui/material';
import { WillFormVM } from 'front-office/view-models/certificate/will-form';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import InputKeyboard from 'shell/components/shared/input-keyboard';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import { DateTime } from 'luxon';

interface WillProps {
  will?: WillFormVM;
  onFieldWillChange: (key: keyof WillFormVM, value: WillFormVM[keyof WillFormVM]) => void;
}

const WillComponent = ({ will, onFieldWillChange }: WillProps): React.ReactElement => {
  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Testamento</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Identificativo"
            id="isOlografo"
            value={will?.isOlografo || ''}
            onChange={(event) => onFieldWillChange('isOlografo', event.target.value)}
          >
            <FormControlLabel value="Olografo" control={<Radio />} label="Olografo" />
            <FormControlLabel value="Pubblico" control={<Radio />} label="Pubblico" />
            <FormControlLabel value="Segreto" control={<Radio />} label="Segreto" />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={9}>
        <InputKeyboard
          label="Cognome notaio"
          id="surnameNotary"
          aria-label="Cognome notaio"
          onChange={(value) => onFieldWillChange('surnameNotary', value)}
          value={will?.surnameNotary || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutSurnameNotary"
              checked={will?.withoutSurnameNotary || false}
              onChange={() =>
                onFieldWillChange('withoutSurnameNotary', !will?.withoutSurnameNotary)
              }
              inputProps={{ 'aria-label': 'Persona senza cognome' }}
            />
          }
          label="Persona senza cognome"
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <InputKeyboard
          label="Nome notaio"
          id="nameNotary"
          aria-label="Nome notaio"
          onChange={(value) => onFieldWillChange('nameNotary', value)}
          value={will?.nameNotary || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutNameNotary"
              checked={will?.withoutNameNotary || false}
              onChange={() => onFieldWillChange('withoutNameNotary', !will?.withoutNameNotary)}
              inputProps={{ 'aria-label': 'Persona senza nome' }}
            />
          }
          label="Persona senza nome"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MunicipalityList
          value={will?.municipalityNotary || null}
          onChange={(municipality) => onFieldWillChange('municipalityNotary', municipality)}
          label="Comune studio notaio"
          fromDate={DateTime.now()}
          id="municipalityNotary"
        />
      </Grid>
      {/* {will?.isOlografo === 'Olografo' || will?.isOlografo === 'Pubblico' ? ( */}
      <Grid item container spacing={2}>
        <Grid item xs={12} md={5}>
          <PmiTextField
            label="Repertorio NR"
            aria-label="Repertorio NR"
            id="repertoire"
            fullWidth
            type="text"
            onChange={(event) => {
              onFieldWillChange('repertoire', event?.target.value);
            }}
            value={will?.repertoire || ''}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <DatePicker
            label="Registrato il"
            aria-label="Registrato il"
            value={will?.dateWill || null}
            onChange={(date) => {
              onFieldWillChange('dateWill', date);
            }}
            renderInput={(params) => (
              <PmiTextField {...params} id="dateWill" fullWidth helperText="" />
            )}
          />
        </Grid>
      </Grid>
      {/* ) : undefined} */}
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Identificativo"
            id="isUnicoErede"
            value={will?.isUnicoErede || 'false'}
            onChange={() => onFieldWillChange('isUnicoErede', !will?.isUnicoErede)}
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              label="Con detto testamento il defunto nominava un solo erede a titolo universale"
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="Con detto testamento il defunto nominava eredi"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          aria-label={will?.isUnicoErede ? 'Dati erede universale' : 'Eredi nominati'}
          label={will?.isUnicoErede ? 'Dati erede universale *' : 'Eredi nominati *'}
          id="heirData"
          name="heirData"
          fullWidth
          type="text"
          variant="outlined"
          value={will?.heirData || ''}
          onChange={(event) => {
            onFieldWillChange('heirData', event?.target.value);
          }}
          multiline
          rows={3}
        />
      </Grid>
      {/* <Grid item xs={12} md={9}>
        <InputKeyboard
          label="Cognome nominato"
          id="surnameAppointed"
          aria-label="Cognome nominato"
          onChange={(value) => onFieldWillChange('surnameAppointed', value)}
          value={will?.surnameAppointed || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutSurnameAppointed"
              checked={will?.withoutSurnameAppointed || false}
              onChange={() =>
                onFieldWillChange('withoutSurnameAppointed', !will?.withoutSurnameAppointed)
              }
              inputProps={{ 'aria-label': 'Persona senza cognome' }}
            />
          }
          label="Persona senza cognome"
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <InputKeyboard
          label="Nome nominato"
          id="nameAppointed"
          aria-label="Nome notaio"
          onChange={(value) => onFieldWillChange('nameAppointed', value)}
          value={will?.nameAppointed || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutNameAppointed"
              checked={will?.withoutNameAppointed || false}
              onChange={() =>
                onFieldWillChange('withoutNameAppointed', !will?.withoutNameAppointed)
              }
              inputProps={{ 'aria-label': 'Persona senza nome' }}
            />
          }
          label="Persona senza nome"
        />
      </Grid> */}
    </Grid>
  );
};

WillComponent.displayName = 'Will component';

const Will = memo(WillComponent);

export default Will;
